import { Injectable } from '@nestjs/common';
import { RmToleranceDTO } from './rm-tolerance.dto';
import { RmTolerance } from '../rm-tolerance.entity';

@Injectable()
export class RmToleranceAdapter {
    
    public convertDtoToEntity(RmToleranceDTO: RmToleranceDTO,  isUpdate: boolean = false) : RmTolerance {
        const rmTolerance = new RmTolerance();
        rmTolerance.rmToleranceId=RmToleranceDTO.rmToleranceId;
        rmTolerance.date=RmToleranceDTO.date;
        rmTolerance.looseShell=RmToleranceDTO.looseShell;
        rmTolerance.softShell=RmToleranceDTO.softShell;
        rmTolerance.fungus=RmToleranceDTO.fungus;

        rmTolerance.isActive=RmToleranceDTO.isActive==undefined?true:RmToleranceDTO.isActive;
        if (isUpdate) {
            rmTolerance.updatedUser = RmToleranceDTO.updatedUser;
        } else {
            rmTolerance.isActive = true;
            rmTolerance.createdUser =RmToleranceDTO.createdUser;
        }
       return rmTolerance;
      }
      public convertEntityToDto(rmToleranceObject: RmTolerance): RmToleranceDTO {
        const rmToleranceDTO= new RmToleranceDTO;
        rmToleranceDTO.rmToleranceId=rmToleranceObject.rmToleranceId;
        rmToleranceDTO.date=rmToleranceObject.date;
        rmToleranceDTO.looseShell=rmToleranceObject.looseShell;
        rmToleranceDTO.softShell=rmToleranceObject.softShell;
        rmToleranceDTO.fungus=rmToleranceObject.fungus;
        rmToleranceDTO.isActive=rmToleranceObject.isActive;
        rmToleranceDTO.createdAt=rmToleranceObject.createdAt;
        rmToleranceDTO.updatedAt=rmToleranceObject.updatedAt;
        rmToleranceDTO.createdUser=rmToleranceObject.createdUser;
        rmToleranceDTO.updatedUser=rmToleranceObject.updatedUser;
        rmToleranceDTO.versionFlag=rmToleranceObject.versionFlag;
        return rmToleranceDTO;
      }
    }
